import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcFilter(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.898 6.493a2.751 2.751 0 1 1 0-1.486A1 1 0 0 1 18 5h2a.75.75 0 0 1 0 1.5h-2a1 1 0 0 1-.102-.007M16.5 5.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M6.102 12.743a1 1 0 0 1-.1.007h-2a.75.75 0 0 1 0-1.5h2q.05 0 .1.007a2.751 2.751 0 1 1 0 1.486M7.5 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M17.898 18.993a2.751 2.751 0 1 1 0-1.486A1 1 0 0 1 18 17.5h2a.75.75 0 0 1 0 1.5h-2a1 1 0 0 1-.102-.007M16.5 18.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 5a.75.75 0 0 0 0 1.5h6A.75.75 0 0 0 10 5zM14.002 11.25a.75.75 0 1 0 0 1.5h6a.75.75 0 0 0 0-1.5zM4 17.5A.75.75 0 0 0 4 19h6a.75.75 0 0 0 0-1.5z"
  }));
}
var IcFilter = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFilter));

export { IcFilter as I };
